import ListAltIcon from '@material-ui/icons/ListAlt';
import { useLocation } from 'react-router-dom';
import { Event } from '../../api/events';
import { getRoutePath, Pages } from '../../router/constants';
import PopupIcon from '../common/popup-icon';

interface AgendaIconProps {
  session: Event;
}

function AgendaIcon({ session }: AgendaIconProps) {
  const location = useLocation();

  return (
    <PopupIcon
      to={{
        pathname: getRoutePath(Pages.SESSIONS_DETAILS, {
          sessionId: session.id,
        }),
        search: 'anchor=description',
        state: {
          prevPath: `${location.pathname}${location.search}`,
        },
      }}
      icon={<ListAltIcon />}
      testId='founder-notes-icon'
      content={session.description}
      emptyText='The report is not submitted.'
      isNoIcon={!session.description || !session.agendaReceived}
    />
  );
}

export default AgendaIcon;
